// Getting percentage, returns 0 if missing information
export const gerPercentage = (quantity?: number, total?: number) =>
    quantity && total ? Math.round((quantity * 100) / total) : 0;
